import { useEffect } from 'react'
import Accesso from 'components/accesso/Accesso'
import ConfigManager from 'components/config/ConfigManager'
import { ELENCHI } from 'configuration/ConfigurazioneElenchi'
import { CHIAVI_ROUTES } from 'configuration/ConfigurazioneRotte'
import { DATICONDUCENTE_HOME } from 'configuration/datiConducente'
import { LINK_SERVIZI } from 'configuration/link'
import { useDatiConducenteContext } from 'context/DatiConducenteProvider'
import DatiConducenteContenitore from './DatiConducenteContenitore'

const CFG = DATICONDUCENTE_HOME
const CFG_SERVIZI = LINK_SERVIZI

export default function DatiConducenteHome() {
  const {
    salvaChiaveVerbale,
    salvaVerbale,
    setListaVerbali,
    setChiaveVerbaleCompletamento,
  } = useDatiConducenteContext()

  useEffect(() => {
    salvaVerbale(null)
    setListaVerbali(null)
    setChiaveVerbaleCompletamento(null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ConfigManager
      elenchiConfig={[ELENCHI.CFG_DATICONDUCENTE_HOME, ELENCHI.CFG_LINK_SERVIZI]}
      render={({ val }) =>
        <DatiConducenteContenitore>
          <Accesso
            attivo={val(CFG_SERVIZI.DATICONDUCENTE_ATTIVO)}
            spidAttivo={val(CFG.SPID_ATTIVO)}
            cieAttivo={val(CFG.CIE_ATTIVO)}
            chiaveWebAttivo={val(CFG.CHIAVE_WEB_ATTIVO)}
            propsChiaveWeb={{ salvaChiaveVerbale, salvaVerbale }}
            chiaveRottaDopoAccesso={CHIAVI_ROUTES.DATI_CONDUCENTE_VERBALE}
          />
        </DatiConducenteContenitore>
      }
    />
  )
}